var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("detail", {
        attrs: {
          prop: _vm.counterpartyRole,
          value: _vm.tx.counterparty,
          copiable: true
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_amount(),
          value:
            _vm.i18n.c(_vm.swimBalance(_vm.tx.amount, _vm.tx.asset)) +
            " " +
            _vm.formatTokenDisplay(_vm.tx.asset)
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_sender_fee(),
          value:
            _vm.i18n.c(_vm.swimBalance(+_vm.tx.fees.source, _vm.tx.asset)) +
            " " +
            _vm.formatTokenDisplay(_vm.tx.asset)
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_recipient_fee(),
          value:
            _vm.i18n.c(_vm.swimBalance(_vm.tx.fees.destination, _vm.tx.asset)) +
            " " +
            _vm.formatTokenDisplay(_vm.tx.asset)
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_fee_from_source(),
          value: _vm.tx.sourcePaysForDest
            ? _vm.i18n.lbl_yes()
            : _vm.i18n.lbl_no()
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_date(), value: _vm.tx.date }
      }),
      _vm._v(" "),
      _vm.isExchange
        ? [
            _c("detail", {
              attrs: {
                prop: _vm.i18n.lbl_subject(),
                value: "" + _vm.tx.subject
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41f40414", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41f40414","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/components/Details.TransferV2.vue
// module id = OIAw
// module chunks = 1